export default __webpack_public_path__ + "static/media/user.8d327b60.svg";